import { takeEvery  } from 'redux-saga';
import { fork, call, put  } from 'redux-saga/effects';

let url
export const getTransit = (next, location) => { 
   //console.log(location, '============location1111============here')

  url = 'https://transitapi.traffy.in.th/api/prediction/get_bus_with_predict.php?longitude='+ location[1] +'&latitude='+ location[0]
  

  if (next){
    url = next
  }
  return fetch(url).then(function (response) {
    return response.json().then(function (json) {
        return json
    })
  })
};

function* callGetTransit({ resolve, reject, next, location }) {
  let result_transit = yield call(getTransit, next, location);
  // console.log(result_transit, '=============result_stop')
  console.log(url)
  if (result_transit.results) {
    yield put({type: "TRANSIT_FETCHED", result_transit});
    yield call(resolve);
  } else {
    yield call(reject, {location:'No data for that location'});
  }
}

function* getTransitSaga() {
  yield* takeEvery("FETCH_TRANSIT", callGetTransit);
}

























///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const getStop = (next, location) => {
  console.log(location[0], location[1], '============location1111============here')
  let url = 'https://transitapi.traffy.in.th/api/prediction/get_bus_with_predict.php?longitude=98.3956&latitude=7.87825'
  // let url = 'http://cloud.traffy.in.th/attapon/API/mockup/prediction.php'

  if (next){
    url = next
  }
  return fetch(url).then(function (response) {
    return response.json().then(function (json) {
      return json
    })
  })
};


function* callGetStop({ resolve, reject, next, location }) {
  let result_stop = yield call(getStop, next, location);
  console.log(result_stop, '=============result_stop')
  if (result_stop.results) {
    yield put({type: "STOP_FETCHED", result_stop});
    yield call(resolve);
  } else {
    yield call(reject, {location:'No data for that location'});
  }
}


function* getStopSaga() {
  yield* takeEvery("FETCH_STOP", callGetStop);
}


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const getminibus = (next, location) => {
  let url = 'https://kumo.traffy.in.th/attapon/api-transit/vehicle/tracking.php?type=รถสองแถว'

  if (next){
    url = next
  }
  return fetch(url).then(function (response) {
    return response.json().then(function (json) {
      return json
    })
  })
};


function* callGetminibus({ resolve, reject, next, location }) {
  let result_minibus = yield call(getminibus, next, location);
  if (result_minibus) {
    yield put({type: "MINIBUS_FETCHED", result_minibus});
    yield call(resolve);
  } else {
    yield call(reject, {location:'No data for that location'});
  }
}


function* getminibusSaga() {
  yield* takeEvery("FETCH_MINIBUS", callGetminibus);
}


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const getmunicipal = (next, location) => {
  let url = 'https://kumo.traffy.in.th/attapon/api-transit/vehicle/tracking.php?type=รถตรวจการ'

  if (next){
    url = next
  }
  return fetch(url).then(function (response) {
    return response.json().then(function (json) {
      return json
    })
  })
};


function* callGetmunicipal({ resolve, reject, next, location }) {
  let result_municipal = yield call(getmunicipal, next, location);
  if (result_municipal) {
    yield put({type: "MUNICIPAL_FETCHED", result_municipal});
    yield call(resolve);
  } else {
    yield call(reject, {location:'No data for that location'});
  }
}


function* getmunicipalSaga() {
  yield* takeEvery("FETCH_MUNICIPAL", callGetmunicipal);
}


export default function* root() {
  yield [
    fork(getTransitSaga),
    fork(getStopSaga),
    fork(getminibusSaga),
    fork(getmunicipalSaga),
  ]
}



// WEBPACK FOOTER //
// ./src/sagas/sagas.js